import { AxiosInstance } from "axios"
import handleQueryResult from "./api/util/handleQueryResult"

// TODO: BESH: CORE-10205 Add other fields from specification
export type GenesisCareImportRecord = {
    record_id: string
    record_date: string
}

export type GenesisCareImportRecordModel = {
	responseRecordId: string
	retrievalDate: string
	adHocRequest: boolean
	recordId: string
	recordDate: string
	content: any
}

export type GenesisCareApiResponseModel = {
	responseId: string
	retrievalDate: string
	adHocRequest: boolean
	dataDate: string
	statusCode: number
	recordCount?: number
	content?: string
	errorMessage?: string
}

export type GenesisCareAdHocImportRequestModel = {
	fromDate: string
	toDate: string
}

class GenesisCareIntegrationsClient {
    constructor(private axiosClient: AxiosInstance) {}

    public getImportRecords = ({
		pageIndex,
		pageSize
	}: {
		pageIndex: number
		pageSize: number
	}) => {
		const query = new URLSearchParams()
		query.append("pageIndex", pageIndex.toString())
		query.append("pageSize", pageSize.toString())

		return handleQueryResult(
			this.axiosClient.get<{
				importRecords: GenesisCareImportRecordModel[]
				total: number
			}>(
				`/api/admin/integrations/bridge/genesiscare/records?${query.toString()}`
			)
		)
	}

	public getApiResponses = ({
		pageIndex,
		pageSize
	}: {
		pageIndex: number
		pageSize: number
	}) => {
		const query = new URLSearchParams()
		query.append("pageIndex", pageIndex.toString())
		query.append("pageSize", pageSize.toString())

		return handleQueryResult(
			this.axiosClient.get<{
				importApiResponses: GenesisCareApiResponseModel[]
				total: number
			}>(
				`/api/admin/integrations/bridge/genesiscare/responses?${query.toString()}`
			)
		)
	}

	public deleteAllApiResponses = () =>
		handleQueryResult(
			this.axiosClient.delete(
				"/api/admin/integrations/bridge/genesiscare/clear"
			)
		)

	public replayApiResponse = (responseRecordId: string) => {
		const params = new URLSearchParams()
		params.append("responseRecordId", responseRecordId)
		
		return this.axiosClient.post<void>(
			`/api/admin/import/unpacktransformmerge/genesiscare?${params.toString()}`
		)
	}

	public startImport = async () =>
		this.axiosClient.post<void>(
			`/api/admin/integrations/bridge/genesiscare/import`
		)

	public startAdHocImport = (request: GenesisCareAdHocImportRequestModel) =>
		this.axiosClient.post<void>(
			`/api/admin/integrations/bridge/genesiscare/import/adhoc`,
			request
		)
}

export default GenesisCareIntegrationsClient
